import {
  rollingSubmissionsService,
  type RollingSubmissionsFilters,
} from "@/api/rollingSubmissions.service";
import { useQuery } from "./useApi";

export function useRollingSubmissions(filters?: RollingSubmissionsFilters) {
  return useQuery(
    () => rollingSubmissionsService.getAll(filters),
    [
      filters?.limit,
      filters?.offset,
      filters?.publicationId,
      filters?.practiceAreaId,
      filters?.regionId,
      filters?.status,
      filters?.hasPendingReview,
      filters?.search,
    ],
  );
}

export function useRollingSubmission(id: string) {
  return useQuery(() => rollingSubmissionsService.getById(id), [id]);
}
